import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

export const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-2">
      <Globe className="w-4 h-4 text-gray-600" />
      <Button
        variant="ghost"
        size="sm"
        onClick={() => changeLanguage(language === 'en' ? 'ar' : 'en')}
        className="font-medium"
        data-testid="language-switcher-btn"
      >
        {language === 'en' ? 'العربية' : 'English'}
      </Button>
    </div>
  );
};
